'use strict'

/**
 * Module qui gère l'effacement du texte dans les input quand on clique dessus (ex. Saisissez votre newsletter)
 */

const J_CLEANTEXTONFOCUS = '.j_cleanTextOnFocus'
const J_DATA_DEFAULTVALUE = 'defaultvalue'

/*
 * Set des events pour détecter si c'est le message par défaut dans le champs, et si il faut le supprimer
 */
function setEvent() {
    const $items = $(J_CLEANTEXTONFOCUS)

    $items.each(function (index, inputElement) {
        $(inputElement).on('blur', function (event) {
            setDefaultValueIfEmpty(event.currentTarget)
        })
        $(inputElement).on('focus', function (event) {
            eraseIfDefaultValue(event.currentTarget)
        })
    })
}

/**
 * Vide le champ si il contient la valeur par défaut
 * @param {string} target Element HTML
 */
function eraseIfDefaultValue(target) {
    const focusedInput = target
    const defaultValue = $(focusedInput).data(J_DATA_DEFAULTVALUE)

    if (focusedInput.value === defaultValue) {
        focusedInput.value = ''
    }
}

/**
 * Si le champ est vide, on met la valeur par défaut
 * @param {string} target Element HTML
 */
function setDefaultValueIfEmpty(target) {
    const focusedInput = target
    const defaultValue = $(focusedInput).data(J_DATA_DEFAULTVALUE)

    if (focusedInput.value === '') {
        focusedInput.value = defaultValue
    }
}

/*
 * Set des events pour détecter si c'est le message qui doit être effacé au clique dans le champ. Le message est la valeur du champ au moment de l'appel du setEvent
 */
function setEventOnCustomText(val) {
    const $items = $(J_CLEANTEXTONFOCUS)
    $items.off() // On désactive les autres events sur ces items si elles y sont

    $items.each(function (index, inputElement) {
        $(inputElement).on('blur', function (event) {
            setCustomValueIfEmpty(val, event.currentTarget)
        })
        $(inputElement).on('focus', function (event) {
            eraseIfCustomValue(val, event.currentTarget)
        })
    })
}

/**
 * Vide le champ si il contient la valeur par défaut passée en paramètre
 * @param {string} defaultValue Valeur pas défaut
 * @param {string} target Element HTML
 */
function eraseIfCustomValue(defaultValue, target) {
    const focusedInput = target

    if (focusedInput.value === defaultValue) {
        focusedInput.value = ''
    }
}

/**
 * Si le champ est vide, on met la valeur par défaut passée en paramètre
 * @param {string} defaultValue Valeur pas défaut
 * @param {string} target Element HTML
 */
function setCustomValueIfEmpty(defaultValue, target) {
    const focusedInput = target

    if (focusedInput.value === '') {
        focusedInput.value = defaultValue
    }
}

export default {
    setEvent: setEvent,
    setEventOnCustomText: setEventOnCustomText
}
